<template>
    <div id="omcustom-product-bundled" style="position:relative">
        <v-stage
            v-if="mockups !== null"
            :config="stageConfig"
            class="omcustom-product-bundled"
            ref="stage"
            :style="style"
            crossorigin="anonymous"
        >
            <v-layer>
                <v-rect
                    :config="{
                        width: stageConfig.width / stageConfig.scale.x,
                        height: stageConfig.height / stageConfig.scale.x,
                        fill: '#ffffff'
                    }"
                />
                <template v-for="l in mockups.layers">
                    <mockup-image 
                        v-if="l.type === 'Image'"
                        :key="l.id" 
                        :layer="l"
                        :mockupID="mockups.id"
                    />
                    <mockup-group
                        v-if="l.type === 'Group'"
                        :layer="l"
                        :key="l.id"
                        :mockupID="mockup.id"
                        :ratio="ratio"
                    />
                    <print-area-bundled 
                    :key="l.id"
                    v-if="l.type === 'Printarea'"
                    :layer="l"
                    :personalized="personalized"
                    :artworks="artworks"
                    @loading="
                        loading => {
                            loadings = { ...loadings, [l.id]: loading }
                        }
                    "
                    :ratio="ratio"
                    />
                </template>
            </v-layer>

        </v-stage>
    </div>
</template>

<script>
import { map, get } from 'lodash'
import jQuery from 'jquery'
import MockupImage from './MockupImage'
import MockupGroup from './MockupGroup'
import PrintAreaBundled from './PrintAreaBundled';
import html2canvas from 'html2canvas';
export default {
  components: { MockupImage, MockupGroup, PrintAreaBundled },
    name: "mockup-product",
    props: {
        layers: {
            type: Array,
            default(){
                return null
            }
        },
        personalized: {
            type: Object,
            default(){
                return null
            }
        },
        artworks: {
            type: Array,
            default(){
                return null
            }
        },
        mockups: {
            type: Object,
            default(){
                return null
            }
        }
    },
    data(){
        return {
            loadings: {}
        }
    },
    computed(){
        jQuery('.konvajs-content')
            .removeClass('konvajs-content')
            .addClass('fabric-content'); 
    },
    created(){
    },
    computed: {
        ratio() {
            const { mockups } = this
            return mockups.width <= 1000 ? 1 : 1000 / mockups.width
        },
        stageConfig() {
            const { mockups, ratio } = this
            return {
                // width: mockups.width * ratio,
                // height: mockups.height * ratio,
                 width: mockups.width  * ratio,
                height: mockups.height  * ratio,
                scale: { x: ratio, y: ratio },
                listening: false
            }
        },
        style() {
            return {
                position: 'relative',
                height: 0,
                paddingBottom: `${(this.mockups.height / this.mockups.width) * 100}%`
            }
        },
        isMockupLoading() {
            const mockupLoading = get(this.mockupLoadings, this.mockups.id, {})
            return map(mockupLoading).some(loading => loading === true)
        },
        isLoading() {
            return map(this.loadings).some(loading => loading === true)
        }
    },
    methods: {
        showCanavs(v){
            v.preventDefault()
            const cv = document.querySelector(".omcustom-product-bundled canvas");
            // console.log(cv.toDataURL())
        },
        handleClick(evt){
             const stage = evt.target.getStage();
            // stage.childNodes[0].canvas.toDataURL()
            //  console.log(stage.content.children[0].toDataURL())
        }
    }
}
</script>

<style>
    /* .omcustom-product-bundled {
        width: 400px !important;
    } */
    .omcustom-product-bundled .konvajs-content{
        position: absolute !important;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100% !important;
        height: 100% !important;
    }
    .omcustom-product-bundled canvas {
        width: 100% !important;
        height: 100% !important;
    }

    @media (max-width: 767px) {
    /* CSS */
    .omcustom-product-bundled .konvajs-content{
        width: 100vw !important;
        /* height: 100vw !important; */
    }
    
    }
</style>




// WEBPACK FOOTER //
// src/components/BundledProduct/MockupBundled/MockupProduct.vue